// extracted by mini-css-extract-plugin
export default {"wrapper":"UserName_wrapper__YqZSd","name":"UserName_name__O3R0+","button":"UserName_button__mbfkG"};